/**
 * Assign modifier to all links except hovered
 * @param {string} linkSelector
 * @param {string} modifier
 */
export default function fadeNonActiveLinks(linkSelector, modifier) {
  /**
   * Link itself
   * @type {*|[]|NodeListOf<Element>}
   */
  const links = document.querySelectorAll(linkSelector);

  /**
   * Assign modifier to links (with exception)
   * @param {Element|undefined} excludeNode
   */
  function assignModifier(excludeNode) {
    links.forEach((el) => {
      if (!el.isEqualNode(excludeNode)) {
        el.classList.add(modifier);
        el.setAttribute('data-hovered', 'false');
      } else {
        el.setAttribute('data-hovered', 'true');
      }
    });
  }

  /**
   * Remove modifier from all links
   */
  function removeModifiers() {
    links.forEach((el) => {
      el.classList.remove(modifier);
      el.setAttribute('data-hovered', 'false');
    });
  }

  links.forEach((el) => {
    el.addEventListener('mouseenter', (event) => {
      assignModifier(event.target);
    });

    el.addEventListener('mouseleave', () => {
      removeModifiers();
    });
  });
}
